import Immutable from 'immutable';

const Content: {
  reversed: boolean,
  merged: boolean,
  horDistortion: number,
  verDistortion: number,
  horScale: number,
  verScale: number,
  scanLineDir: number,
  originalNrOfInks: number
} = {
  reversed: false,
  merged: false,
  horDistortion: -1.0,
  verDistortion: -1.0,
  horScale: -1.0,
  verScale: -1.0,
  scanLineDir: -1,
  originalNrOfInks: -1
};

class FileInfoDFDimension extends Immutable.Record(Content) {
}



export default FileInfoDFDimension;
